// Mock data for the Kaeros application

export const userData = {
  name: '',
  initials: 'AG',
  role: 'Senior Realtor',
  plan: 'Pro Plan',
  avatar: 'https://i.pravatar.cc/150?img=11',
  email: '',
  phone: '(555) 123-4567',
  license: 'DRE #12345678',
  brokerage: 'Keller Williams Realty',
};

export const dashboardStats = {
  pipelineValue: '$1.2M',
  newLeadsToday: 8,
  newLeadsYesterday: 4,
  actionRequired: 3,
};

export const schedule = [
  {
    id: 1,
    time: '2:00 PM',
    type: 'Zoom',
    title: 'Listing Consult',
    contact: 'Stanley Hudson',
    initials: 'SH',
    score: 75,
    context: 'Owner of 123 Maple Dr. Thinking of selling in Spring. Wants $450k net.',
    icon: 'video',
  },
  {
    id: 2,
    time: '4:30 PM',
    type: 'In-Person',
    title: 'Showing: 550 Beesley St',
    contact: 'Pam Beesly',
    initials: 'PB',
    score: null,
    context: null,
    icon: 'map-pin',
    upcoming: true,
  },
];

export const conversations = [
  {
    id: 1,
    name: 'Michael Scott',
    preview: 'Is the price negotiable?',
    time: '2m',
    unread: true,
    hot: true,
    email: 'michael@dunder.com',
    phone: '+1 570-555-0199',
    history: [
      { type: 'auto', text: "Hi Michael, here are 3 properties I think you'll love based on your budget...", time: 'Yesterday 10:00 AM', channel: 'email' },
      { type: 'them', text: 'Thanks! I really like the first one.', time: 'Yesterday 10:15 AM', channel: 'email' },
      { type: 'me', text: 'Great choice. When would you like to see it?', time: 'Yesterday 11:00 AM', channel: 'sms' },
      { type: 'them', text: 'Is the price negotiable?', time: '2m ago', channel: 'sms' },
    ],
  },
  {
    id: 2,
    name: 'Dwight Schrute',
    preview: 'I need 10 acres.',
    time: '1h',
    unread: true,
    hot: true,
    email: 'dwight@farms.com',
    phone: '+1 570-555-0123',
    history: [
      { type: 'auto', text: 'Hi Dwight, checking in on your land search.', time: 'Mon 9:00 AM', channel: 'sms' },
      { type: 'them', text: 'I need 10 acres. Soil must be arable.', time: '1h ago', channel: 'sms' },
    ],
  },
  {
    id: 3,
    name: 'Pam Beesly',
    preview: 'Thanks!',
    time: '1d',
    unread: false,
    hot: false,
    email: 'pam@art.com',
    phone: '+1 570-555-0000',
    history: [
      { type: 'me', text: 'Hi Pam, confirming our appointment for tomorrow.', time: 'Yesterday', channel: 'sms' },
      { type: 'them', text: 'Thanks! See you then.', time: 'Yesterday', channel: 'sms' },
    ],
  },
  {
    id: 4,
    name: 'Jim Halpert',
    preview: 'Can we meet Tuesday?',
    time: '2d',
    unread: false,
    hot: false,
    email: 'jim@sports.com',
    phone: '+1 570-555-1111',
    history: [
      { type: 'me', text: 'Hey Jim, are we still on for the viewing?', time: '2 days ago', channel: 'wa' },
      { type: 'them', text: 'Can we meet Tuesday instead?', time: '2 days ago', channel: 'wa' },
    ],
  },
  {
    id: 5,
    name: 'Stanley Hudson',
    preview: 'Did I stutter?',
    time: '3d',
    unread: false,
    hot: true,
    email: 'stanley@crossword.com',
    phone: '+1 570-555-2222',
    history: [
      { type: 'auto', text: 'Happy Retirement! Thinking of selling?', time: '3 days ago', channel: 'email' },
      { type: 'them', text: 'Did I stutter? Leave me alone.', time: '3 days ago', channel: 'email' },
    ],
  },
  {
    id: 6,
    name: 'Angela Martin',
    preview: 'The cats need space.',
    time: '4d',
    unread: true,
    hot: false,
    email: 'angela@cats.com',
    phone: '+1 570-555-3333',
    history: [
      { type: 'me', text: 'Hi Angela, found a place with a sunroom.', time: '4 days ago', channel: 'sms' },
      { type: 'them', text: 'The cats need space. Is it south facing?', time: '4 days ago', channel: 'sms' },
    ],
  },
];

export const leads = [
  {
    id: 1,
    name: 'Michael Scott',
    email: 'michael@dunder.com',
    phone: '+1 570-555-0199',
    isHot: true,
    status: 'Appt Set',
    statusColor: 'blue',
    automation: { name: 'Buyer Plan', step: 3, total: 5 },
    interest: '123 Main St, Scranton',
    tags: ['Zillow', 'Buyer'],
    lastContact: '2m ago',
  },
  {
    id: 2,
    name: 'Dwight Schrute',
    email: 'dwight@farms.com',
    phone: '+1 570-555-0123',
    isHot: false,
    status: 'New Lead',
    statusColor: 'stone',
    automation: { name: 'Farm Outreach', step: 1, total: 10 },
    interest: 'Schrute Farms, PA',
    tags: ['Farm', 'Seller'],
    lastContact: '1h ago',
  },
  {
    id: 3,
    name: 'Pam Beesly',
    email: 'pam@art.com',
    phone: '+1 570-555-0000',
    isHot: false,
    status: 'Closed',
    statusColor: 'green',
    automation: null,
    interest: '55 Willow Rd',
    tags: ['Referral'],
    lastContact: '8d ago',
    archived: true,
  },
];

export const workflows = [
  {
    id: 1,
    name: 'Open House Follow-up',
    icon: 'home',
    trigger: 'Form Submit',
    active: true,
    stats: { active: 14, openRate: '62%', replies: '8%' },
    lastEdited: '2d ago',
    steps: [
      { id: 1, type: 'trigger', title: 'Form Submission', subtitle: 'Any Property Page', icon: 'play' },
      { id: 2, type: 'sms', title: 'Welcome SMS', subtitle: 'Send immediately', icon: 'message-square' },
      { id: 3, type: 'wait', title: 'Wait 1 Day', subtitle: 'Pauses workflow', icon: 'clock' },
      { id: 4, type: 'email', title: 'Follow-up Email', subtitle: 'With brochure', icon: 'mail' },
      { id: 5, type: 'wait', title: 'Wait 3 Days', subtitle: null, icon: 'clock' },
      { id: 6, type: 'sms', title: 'Final Check-in', subtitle: 'Personal touch', icon: 'message-square' },
    ],
  },
  {
    id: 2,
    name: 'Cold Lead Revival',
    icon: 'thermometer-snowflake',
    trigger: 'Manual Add',
    active: false,
    stats: { active: 0, openRate: '--', replies: '--' },
    lastEdited: '5d ago',
    steps: [],
  },
];

export const pausedLeads = [
  {
    id: 1,
    name: 'Pam Beesly',
    email: 'pam@art.com',
    workflow: 'Open House Follow-up',
    stoppedAt: 'Step 3 (SMS)',
    reason: 'Replied',
    reasonIcon: 'message-circle',
    reasonColor: 'orange',
    time: '2h ago',
  },
  {
    id: 2,
    name: 'Ryan Howard',
    email: 'ryan@wuphf.com',
    workflow: 'Cold Lead Revival',
    stoppedAt: 'Step 1',
    reason: 'Archived',
    reasonIcon: 'archive',
    reasonColor: 'stone',
    time: '1d ago',
  },
];

export const properties = [
  {
    id: 1,
    address: '123 Main St',
    city: 'Scranton, PA 18503',
    price: '$450,000',
    beds: 3,
    baths: 2,
    sqft: '2,400',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=400&q=80',
    status: 'Active',
    views: 142,
    leads: 8,
  },
  {
    id: 2,
    address: '456 Oak Ave',
    city: 'Scranton, PA 18503',
    price: '$325,000',
    beds: 2,
    baths: 1,
    sqft: '1,800',
    image: null,
    status: 'Draft',
    views: 0,
    leads: 0,
  },
];

export const formResponses = [
  {
    id: 1,
    name: 'Michael Scott',
    status: 'Active',
    time: '2m ago',
  },
  {
    id: 2,
    name: 'Angela Martin',
    status: 'New',
    time: '1h ago',
  },
];

export const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: 'layout-dashboard', path: '/' },
  { id: 'inbox', label: 'Inbox', icon: 'message-square', path: '/inbox', badge: 3 },
  { id: 'leads', label: 'Leads', icon: 'users', path: '/leads' },
  { id: 'automations', label: 'Automations', icon: 'zap', path: '/automations' },
  { id: 'capture', label: 'Capture Tools', icon: 'magnet', path: '/capture' },
];

